;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="4217d0f2-1eeb-4754-a421-268fbaf19115",e._sentryDebugIdIdentifier="sentry-dbid-4217d0f2-1eeb-4754-a421-268fbaf19115")}catch(e){}}();import classNames from '../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import React__default, { useContext } from 'react';
import { Anchor } from '@zooplus/ui-components';
import AppContext from '../../context/AppContext.js';
import '../../_virtual/_sentry-release-injection-file.js';
import { convertTrackingIdTitle, isSpecialLink, getTrackingId } from '../../utils/categoryUtils.js';
import { LinkTypeEnum } from '../Link/Link.js';
import styles from './CategoryFlyout.module.scss.js';
import { ExpandableCategoryList } from './ExpandableCategoryLinks.js';

function AnimalFlyoutV2({ category }) {
    const { translations } = useContext(AppContext);
    const viewAllLabel = translations.get('shop.header.categories.title.link');
    const { children = [], specials = [], title, path } = category;
    const categories = [...children, ...specials];
    const categoryTrackingId = 'animal';
    const trackingIdTitle = convertTrackingIdTitle(title);
    return (React__default.createElement("div", { className: classNames(styles.animalflyout, styles.scrollBox), "data-zta": `category-flyout-v2-${categoryTrackingId}-${trackingIdTitle}` },
        React__default.createElement("div", { className: styles.flyOutHeader },
            React__default.createElement(Anchor, { href: path, "data-link-type": LinkTypeEnum.PRIMARY, "data-zta": `category-flyout-${trackingIdTitle}-level2-link` },
                viewAllLabel,
                " ",
                title)),
        React__default.createElement("div", { className: styles.animalPanelV2 }, categories.map((categoryL3) => {
            const { children: l3Children = [], specials: l3Specials = [], } = categoryL3;
            const childCategories = [...l3Children, ...l3Specials];
            const hasChildren = childCategories.length > 0;
            const isSpecial = isSpecialLink(categoryL3);
            return (React__default.createElement("ul", { id: getTrackingId({
                    parentTitle: title,
                    type: categoryL3.type,
                    level: categoryL3.level,
                    index: children.findIndex((item) => item.extId === categoryL3.extId),
                    title: categoryL3.title,
                }), className: styles.animalPanelGroup, key: categoryL3.path },
                React__default.createElement("li", { className: styles.groupHeader },
                    React__default.createElement(Anchor, { variant: isSpecial
                            ? 'danger'
                            : LinkTypeEnum.NEUTRAL, "data-link-type": isSpecial
                            ? LinkTypeEnum.OFFER
                            : LinkTypeEnum.NEUTRAL, className: classNames({
                            [styles.nonBoldSpecialsText]: isSpecial && !hasChildren,
                        }), "data-zta": "category-flyout-animal-group-header", "aria-label": "group-header", href: categoryL3.path }, categoryL3.title)),
                hasChildren && (React__default.createElement(ExpandableCategoryList, { categories: childCategories }))));
        }))));
}

export { AnimalFlyoutV2 };
//# sourceMappingURL=AnimalFlyoutV2.js.map
